import { 
    Box,  
      Center,
     Heading ,
     Image,
      } from "@chakra-ui/react"

import CallToActionWithAnnotation from '../Templete/AboutComponete'
const About=()=>{
 return (
 <>
    <Box id='About'  borderRadius={'10px'}boxShadow=' rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'>
        <Center>
            <Heading as='h2'color={'#DC143C'} >-About Me-</Heading>
          
            </Center>
       
        <Center  py={{ base: 10, md: 10 }}><Image src="https://avatars.githubusercontent.com/u/101566216?v=4" borderRadius='50%' w='20%' alt=""/></Center>
     
        <CallToActionWithAnnotation/>
       
     </Box> 
    
 </>
 )
}

export default About